import * as Sentry from "@sentry/nuxt";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const client = Sentry.getClient();
  if (!client) return;

  const options = client.getOptions();
  if (config.public.sentryRelease) options.release = config.public.sentryRelease;
  if (config.public.sentryEnvironment) options.environment = config.public.sentryEnvironment;
});
